// Guard for the admin AI pages: must be a company admin AND the company's AI must be
// enabled. Composes AdminGuard (role) with AiEnabledGuard (company AI state).
import React from "react";
import PropTypes from "prop-types";

import AdminGuard from "./AdminGuard";
import AiEnabledGuard from "./AiEnabledGuard";

const AdminAiGuard = ({ children }) => (
  <AdminGuard>
    <AiEnabledGuard>{children}</AiEnabledGuard>
  </AdminGuard>
);

AdminAiGuard.propTypes = {
  children: PropTypes.node
};

export default AdminAiGuard;
